/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivateHistoryRouteImport } from './routes/_private.history'
import { Route as publicPasswordRouteImport } from './routes/(public)/password'
import { Route as publicLoginRouteImport } from './routes/(public)/login'
import { Route as PrivateVersionsIndexRouteImport } from './routes/_private.versions.index'
import { Route as PrivateUnitsIndexRouteImport } from './routes/_private.units.index'
import { Route as PrivateTemplatesIndexRouteImport } from './routes/_private.templates.index'
import { Route as PrivateRobotsIndexRouteImport } from './routes/_private.robots.index'
import { Route as PrivatePermissionsIndexRouteImport } from './routes/_private.permissions.index'
import { Route as PrivateMailsIndexRouteImport } from './routes/_private.mails.index'
import { Route as PrivateLibrariesIndexRouteImport } from './routes/_private.libraries.index'
import { Route as PrivateFloorplansIndexRouteImport } from './routes/_private.floorplans.index'
import { Route as PrivateFeedbacksIndexRouteImport } from './routes/_private.feedbacks.index'
import { Route as PrivateEventsIndexRouteImport } from './routes/_private.events.index'
import { Route as PrivateDashboardsIndexRouteImport } from './routes/_private.dashboards.index'
import { Route as PrivateCountersIndexRouteImport } from './routes/_private.counters.index'
import { Route as PrivateActivityIndexRouteImport } from './routes/_private.activity.index'
import { Route as PrivateAccountsIndexRouteImport } from './routes/_private.accounts.index'
import { Route as PrivateRobotsCreateRouteImport } from './routes/_private.robots.create'
import { Route as PrivateRobotsIdPositionRouteImport } from './routes/_private.robots.$id.position'

const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateHistoryRoute = PrivateHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => PrivateRoute,
} as any)
const publicPasswordRoute = publicPasswordRouteImport.update({
  id: '/(public)/password',
  path: '/password',
  getParentRoute: () => rootRouteImport,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateVersionsIndexRoute = PrivateVersionsIndexRouteImport.update({
  id: '/versions/',
  path: '/versions/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateUnitsIndexRoute = PrivateUnitsIndexRouteImport.update({
  id: '/units/',
  path: '/units/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateTemplatesIndexRoute = PrivateTemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRobotsIndexRoute = PrivateRobotsIndexRouteImport.update({
  id: '/robots/',
  path: '/robots/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePermissionsIndexRoute = PrivatePermissionsIndexRouteImport.update({
  id: '/permissions/',
  path: '/permissions/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateMailsIndexRoute = PrivateMailsIndexRouteImport.update({
  id: '/mails/',
  path: '/mails/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateLibrariesIndexRoute = PrivateLibrariesIndexRouteImport.update({
  id: '/libraries/',
  path: '/libraries/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateFloorplansIndexRoute = PrivateFloorplansIndexRouteImport.update({
  id: '/floorplans/',
  path: '/floorplans/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateFeedbacksIndexRoute = PrivateFeedbacksIndexRouteImport.update({
  id: '/feedbacks/',
  path: '/feedbacks/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateEventsIndexRoute = PrivateEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDashboardsIndexRoute = PrivateDashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateCountersIndexRoute = PrivateCountersIndexRouteImport.update({
  id: '/counters/',
  path: '/counters/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateActivityIndexRoute = PrivateActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateAccountsIndexRoute = PrivateAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRobotsCreateRoute = PrivateRobotsCreateRouteImport.update({
  id: '/robots/create',
  path: '/robots/create',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRobotsIdPositionRoute = PrivateRobotsIdPositionRouteImport.update({
  id: '/robots/$id/position',
  path: '/robots/$id/position',
  getParentRoute: () => PrivateRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof publicLoginRoute
  '/password': typeof publicPasswordRoute
  '/history': typeof PrivateHistoryRoute
  '/robots/create': typeof PrivateRobotsCreateRoute
  '/accounts/': typeof PrivateAccountsIndexRoute
  '/activity/': typeof PrivateActivityIndexRoute
  '/counters/': typeof PrivateCountersIndexRoute
  '/dashboards/': typeof PrivateDashboardsIndexRoute
  '/events/': typeof PrivateEventsIndexRoute
  '/feedbacks/': typeof PrivateFeedbacksIndexRoute
  '/floorplans/': typeof PrivateFloorplansIndexRoute
  '/libraries/': typeof PrivateLibrariesIndexRoute
  '/mails/': typeof PrivateMailsIndexRoute
  '/permissions/': typeof PrivatePermissionsIndexRoute
  '/robots/': typeof PrivateRobotsIndexRoute
  '/templates/': typeof PrivateTemplatesIndexRoute
  '/units/': typeof PrivateUnitsIndexRoute
  '/versions/': typeof PrivateVersionsIndexRoute
  '/robots/$id/position': typeof PrivateRobotsIdPositionRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof publicLoginRoute
  '/password': typeof publicPasswordRoute
  '/history': typeof PrivateHistoryRoute
  '/robots/create': typeof PrivateRobotsCreateRoute
  '/accounts': typeof PrivateAccountsIndexRoute
  '/activity': typeof PrivateActivityIndexRoute
  '/counters': typeof PrivateCountersIndexRoute
  '/dashboards': typeof PrivateDashboardsIndexRoute
  '/events': typeof PrivateEventsIndexRoute
  '/feedbacks': typeof PrivateFeedbacksIndexRoute
  '/floorplans': typeof PrivateFloorplansIndexRoute
  '/libraries': typeof PrivateLibrariesIndexRoute
  '/mails': typeof PrivateMailsIndexRoute
  '/permissions': typeof PrivatePermissionsIndexRoute
  '/robots': typeof PrivateRobotsIndexRoute
  '/templates': typeof PrivateTemplatesIndexRoute
  '/units': typeof PrivateUnitsIndexRoute
  '/versions': typeof PrivateVersionsIndexRoute
  '/robots/$id/position': typeof PrivateRobotsIdPositionRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/(public)/login': typeof publicLoginRoute
  '/(public)/password': typeof publicPasswordRoute
  '/_private/history': typeof PrivateHistoryRoute
  '/_private/robots/create': typeof PrivateRobotsCreateRoute
  '/_private/accounts/': typeof PrivateAccountsIndexRoute
  '/_private/activity/': typeof PrivateActivityIndexRoute
  '/_private/counters/': typeof PrivateCountersIndexRoute
  '/_private/dashboards/': typeof PrivateDashboardsIndexRoute
  '/_private/events/': typeof PrivateEventsIndexRoute
  '/_private/feedbacks/': typeof PrivateFeedbacksIndexRoute
  '/_private/floorplans/': typeof PrivateFloorplansIndexRoute
  '/_private/libraries/': typeof PrivateLibrariesIndexRoute
  '/_private/mails/': typeof PrivateMailsIndexRoute
  '/_private/permissions/': typeof PrivatePermissionsIndexRoute
  '/_private/robots/': typeof PrivateRobotsIndexRoute
  '/_private/templates/': typeof PrivateTemplatesIndexRoute
  '/_private/units/': typeof PrivateUnitsIndexRoute
  '/_private/versions/': typeof PrivateVersionsIndexRoute
  '/_private/robots/$id/position': typeof PrivateRobotsIdPositionRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/password'
    | '/history'
    | '/robots/create'
    | '/accounts/'
    | '/activity/'
    | '/counters/'
    | '/dashboards/'
    | '/events/'
    | '/feedbacks/'
    | '/floorplans/'
    | '/libraries/'
    | '/mails/'
    | '/permissions/'
    | '/robots/'
    | '/templates/'
    | '/units/'
    | '/versions/'
    | '/robots/$id/position'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/password'
    | '/history'
    | '/robots/create'
    | '/accounts'
    | '/activity'
    | '/counters'
    | '/dashboards'
    | '/events'
    | '/feedbacks'
    | '/floorplans'
    | '/libraries'
    | '/mails'
    | '/permissions'
    | '/robots'
    | '/templates'
    | '/units'
    | '/versions'
    | '/robots/$id/position'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/(public)/login'
    | '/(public)/password'
    | '/_private/history'
    | '/_private/robots/create'
    | '/_private/accounts/'
    | '/_private/activity/'
    | '/_private/counters/'
    | '/_private/dashboards/'
    | '/_private/events/'
    | '/_private/feedbacks/'
    | '/_private/floorplans/'
    | '/_private/libraries/'
    | '/_private/mails/'
    | '/_private/permissions/'
    | '/_private/robots/'
    | '/_private/templates/'
    | '/_private/units/'
    | '/_private/versions/'
    | '/_private/robots/$id/position'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  publicLoginRoute: typeof publicLoginRoute
  publicPasswordRoute: typeof publicPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/history': {
      id: '/_private/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof PrivateHistoryRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/(public)/password': {
      id: '/(public)/password'
      path: '/password'
      fullPath: '/password'
      preLoaderRoute: typeof publicPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private/versions/': {
      id: '/_private/versions/'
      path: '/versions'
      fullPath: '/versions/'
      preLoaderRoute: typeof PrivateVersionsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/units/': {
      id: '/_private/units/'
      path: '/units'
      fullPath: '/units/'
      preLoaderRoute: typeof PrivateUnitsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/templates/': {
      id: '/_private/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof PrivateTemplatesIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/robots/': {
      id: '/_private/robots/'
      path: '/robots'
      fullPath: '/robots/'
      preLoaderRoute: typeof PrivateRobotsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/permissions/': {
      id: '/_private/permissions/'
      path: '/permissions'
      fullPath: '/permissions/'
      preLoaderRoute: typeof PrivatePermissionsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/mails/': {
      id: '/_private/mails/'
      path: '/mails'
      fullPath: '/mails/'
      preLoaderRoute: typeof PrivateMailsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/libraries/': {
      id: '/_private/libraries/'
      path: '/libraries'
      fullPath: '/libraries/'
      preLoaderRoute: typeof PrivateLibrariesIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/floorplans/': {
      id: '/_private/floorplans/'
      path: '/floorplans'
      fullPath: '/floorplans/'
      preLoaderRoute: typeof PrivateFloorplansIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/feedbacks/': {
      id: '/_private/feedbacks/'
      path: '/feedbacks'
      fullPath: '/feedbacks/'
      preLoaderRoute: typeof PrivateFeedbacksIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/events/': {
      id: '/_private/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof PrivateEventsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/dashboards/': {
      id: '/_private/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof PrivateDashboardsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/counters/': {
      id: '/_private/counters/'
      path: '/counters'
      fullPath: '/counters/'
      preLoaderRoute: typeof PrivateCountersIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/activity/': {
      id: '/_private/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof PrivateActivityIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/accounts/': {
      id: '/_private/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof PrivateAccountsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/robots/create': {
      id: '/_private/robots/create'
      path: '/robots/create'
      fullPath: '/robots/create'
      preLoaderRoute: typeof PrivateRobotsCreateRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/robots/$id/position': {
      id: '/_private/robots/$id/position'
      path: '/robots/$id/position'
      fullPath: '/robots/$id/position'
      preLoaderRoute: typeof PrivateRobotsIdPositionRouteImport
      parentRoute: typeof PrivateRoute
    }
  }
}

interface PrivateRouteChildren {
  PrivateHistoryRoute: typeof PrivateHistoryRoute
  PrivateRobotsCreateRoute: typeof PrivateRobotsCreateRoute
  PrivateAccountsIndexRoute: typeof PrivateAccountsIndexRoute
  PrivateActivityIndexRoute: typeof PrivateActivityIndexRoute
  PrivateCountersIndexRoute: typeof PrivateCountersIndexRoute
  PrivateDashboardsIndexRoute: typeof PrivateDashboardsIndexRoute
  PrivateEventsIndexRoute: typeof PrivateEventsIndexRoute
  PrivateFeedbacksIndexRoute: typeof PrivateFeedbacksIndexRoute
  PrivateFloorplansIndexRoute: typeof PrivateFloorplansIndexRoute
  PrivateLibrariesIndexRoute: typeof PrivateLibrariesIndexRoute
  PrivateMailsIndexRoute: typeof PrivateMailsIndexRoute
  PrivatePermissionsIndexRoute: typeof PrivatePermissionsIndexRoute
  PrivateRobotsIndexRoute: typeof PrivateRobotsIndexRoute
  PrivateTemplatesIndexRoute: typeof PrivateTemplatesIndexRoute
  PrivateUnitsIndexRoute: typeof PrivateUnitsIndexRoute
  PrivateVersionsIndexRoute: typeof PrivateVersionsIndexRoute
  PrivateRobotsIdPositionRoute: typeof PrivateRobotsIdPositionRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateHistoryRoute: PrivateHistoryRoute,
  PrivateRobotsCreateRoute: PrivateRobotsCreateRoute,
  PrivateAccountsIndexRoute: PrivateAccountsIndexRoute,
  PrivateActivityIndexRoute: PrivateActivityIndexRoute,
  PrivateCountersIndexRoute: PrivateCountersIndexRoute,
  PrivateDashboardsIndexRoute: PrivateDashboardsIndexRoute,
  PrivateEventsIndexRoute: PrivateEventsIndexRoute,
  PrivateFeedbacksIndexRoute: PrivateFeedbacksIndexRoute,
  PrivateFloorplansIndexRoute: PrivateFloorplansIndexRoute,
  PrivateLibrariesIndexRoute: PrivateLibrariesIndexRoute,
  PrivateMailsIndexRoute: PrivateMailsIndexRoute,
  PrivatePermissionsIndexRoute: PrivatePermissionsIndexRoute,
  PrivateRobotsIndexRoute: PrivateRobotsIndexRoute,
  PrivateTemplatesIndexRoute: PrivateTemplatesIndexRoute,
  PrivateUnitsIndexRoute: PrivateUnitsIndexRoute,
  PrivateVersionsIndexRoute: PrivateVersionsIndexRoute,
  PrivateRobotsIdPositionRoute: PrivateRobotsIdPositionRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  publicLoginRoute: publicLoginRoute,
  publicPasswordRoute: publicPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
